import React from "react";

const LoadingSharedFile = () => {
    return(
        <div className="loading_container_share fade-in">
            <div className="header_loading_share"></div>
        </div>
    )
}

export default LoadingSharedFile